import { Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import FinanciarFunctions from './FinanciarFunctions';
import InterpretareComponent1 from './InterpretareComponent1';
import InterpretareLabelComponent from './InterpretareLabelComponent';
import ChartFurnizori from './ChartFurnizori';
import Utils from '../../providers/Utils';


export default class RaportSolduriFurnizori extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            arrow1: false,
            arrow2: false,
            arrow3: false,
          

        }
    }

    componentDidMount() {
    }

    u = new Utils()

    displayArrow = (arr) => {

        this.setState({ [arr]: true })
    }

    f = new FinanciarFunctions()
    render() {
        return (
            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.solduriFurnizori} </h5>


                    <Divider className='pm-divider' />
                </Grid>

                <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <Grid container>
                                <Grid style={{ textAlign: 'left', lineHeight: 1 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <span style={{ fontSize: 12, color: 'rgb(121	121	121	)' }}>{this.dictionary.financiar.solduriFurnizoriMesaj}</span>
                                </Grid>

                                <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container>
                                        {this.props.bilanturiAsc.map((b, idx) => {
                                            return (

                                                <Grid key={idx} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                    <Grid container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600, color: 'black' }}>{b.an}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.u.formatNumber(this.f.solduriFurnizori(b)) } Lei</span>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                            )
                                        })}
                                    </Grid>


                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <ChartFurnizori
                                bilanturi={this.props.bilanturiAsc}
                                />
                        </Grid>


                    </Grid>
                    <Divider style={{ marginTop: 20 }} className='pm-divider' />
                </Grid>

                <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            {this.props.bilanturiDesc &&
                                <InterpretareComponent1
                                labels={[this.dictionary.financiar.slab , this.dictionary.financiar.mediu, this.dictionary.financiar.foarteBine]}
                                    arrow1={this.state.arrow1}
                                    arrow2={this.state.arrow2}
                                    arrow3={this.state.arrow3}
                                    displayArrow={this.displayArrow}
                                    interpretare2={true}
                                    val1={this.f.diferentaTotalSoldFurnizori(this.props.bilanturiDesc[0], this.props.bilanturiDesc[1])}
                                    val2={null}
                                    cF1={10}
                                    cF2={20}
                                />
                            }

                        </Grid>

                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            {this.props.bilanturiDesc &&
                                <InterpretareLabelComponent
                                    interpretare2={true}
                                    slab={this.dictionary.financiar.slab}
                                    mediu={this.dictionary.financiar.mediu}
                                    foarteBine={this.dictionary.financiar.foarteBine}
                                    dictionary={this.dictionary}
                                    val1={this.f.diferentaTotalSoldFurnizori(this.props.bilanturiDesc[0], this.props.bilanturiDesc[1])}
                                    val2={null}
                                    cF1={10}
                                    cF2={20}
                                />
                            }
                        </Grid>

                    </Grid>

                </Grid>

                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <span style={{ fontSize: 12 }}> {this.dictionary.financiar.solduriFurnizoriText}</span>


                </Grid>
            </Grid>
        );
    }
}